import PropTypes from 'prop-types';
import React from 'react';
import { HelpBlock, FormGroup, ControlLabel, FormControl } from 'react-bootstrap';

export default class RunNameInput extends React.Component {
  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
  }

  onChange(e) {
    const runNameInput = e.target.value.replace(/[^\w\s]/gi, '');
    this.props.onChange(runNameInput);
  }

  render() {
    return (
      <FormGroup>
        <ControlLabel>Run Name</ControlLabel>
        <FormControl
          type='text'
          value={this.props.value}
          className='secondary-input'
          onChange={this.onChange}
        />
        <HelpBlock>A label identifying the scenario you wish to analyze</HelpBlock>
      </FormGroup>
    );
  }
}

RunNameInput.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
};
